export abstract class CommonConstants {
  static readonly MIN_SEARCH_QUERY_LENGTH = 3;
  static readonly SEARCH_DEBOUNCE_TIME_MS = 300;
}
